/* eslint-disable */
import { getCookie } from "@/utils/cookies";

import { getMarketingChannel, getOS } from "./common";
import { getSiteProps } from "./siteProps";

const isMobile =
  typeof navigator !== "undefined" &&
  /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const isApp = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has("app") && urlParams.get("app") === "true";
};

let userEmail = "";
const fetchUserDetails = async () => {
  let data = null;
  try {
    const res = await fetch(
      `${window.location.origin}/seeker-profile/api/rioMe`,
      {
        method: "GET",
      },
    );
    data = await res.json();
    userEmail = data.primaryEmail.email;
  } catch (error) {
    // console.log("res", error);
  }
  return data;
};

const publishEvent = async (payload) => {
  try {
    const res = await fetch(
      `${window.location.origin}/seeker-profile/api/publishEvents`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      },
    );
    await res.json();
  } catch (error) {
    // console.log("res", error);
  }
};

if (typeof document === "object") getCookie("MSSOCLIENT") && fetchUserDetails();

export default {
  getPageData: function (argument) {
    let pageNameMap = {
      "/seeker/job-details": "JD",
      "/seeker/job-details/": "JD",
      "/search/results": "SRP",
      "/search/results/": "SRP",
      "/search/walkin-jobs": "walkinSRP",
      "/search/walkin-jobs/": "walkinSRP",
      "/seeker/dashboard": "dashboard",
      "/seeker/dashboard/": "dashboard",
      "/seeker/profile": "NewProfile",
      "/seeker/registration": "NewRegistration",
      "/seeker-profile/registration": "NewRegistration",
      "/seeker-profile/profile": "NewProfile",
      "/seeker-profile/dashboard": "Dashboard",
      search: "Search-Page",
      job: "Job-Detail",
      "/home/user": "homepage",
      "/home": "homepage",
      "/": "homepage",
      "/user": "homepage",
    };
    const path = window.location.pathname;
    const pathWithoutTrailingSlash = this.removeTrailingSlash(path);
    if (pageNameMap[pathWithoutTrailingSlash]) {
      return pageNameMap[path];
    } else {
      let pathArr = path.split("/");
      if (pathArr && pathArr.length) {
        if (pathArr[1]) {
          return pageNameMap[pathArr[1]];
        }
      }
    }
    return "";
  },
  eventPush: async function (eveName, properties) {
    //eveName is a string for event Name
    //properties is an object with key value pair for user proprties to be captured
    const date_time = new Date();
    let spl = this.getQueryString()["spl"];
    if (!spl) spl = "";

    let page_name = properties.page_name;
    if (!page_name) page_name = this.getPageData();

    properties["campaign_name"] = spl;
    properties["page_name"] = page_name;
    properties["channel_id"] = window.channel_id || "";
    properties["sub_channel_id"] = window.sub_channel_id;
    properties["date_time"] = date_time;
    properties["platform"] = isApp() ? "App" : isMobile ? "Mobile" : "Desktop";
    properties["referrer"] = document.referrer || window.location?.href;
    getCookie("MSSOCLIENT") && (properties.email_id = userEmail || "");

    if (window._ctProps) {
      window._ctProps.push(eveName, properties);
    } else {
      !window._clevertapEventStack && (window._clevertapEventStack = []);
      window._clevertapEventStack.push({
        evntName: eveName,
        eventObj: properties,
      });
    }
  },
  eventPageView: function () {
    let page_name = this.getPageData();

    const dt = new Date();
    let spl = this.getQueryString()["spl"];
    if (!spl) spl = "";
    const eveName = "PageViewed";

    const search = window.location.search;
    let urlParams = new URLSearchParams(search);
    const utm_campaign = urlParams.get("utm_campaign");
    const utm_medium = urlParams.get("utm_medium");
    const utm_source = urlParams.get("utm_source");
    const utm_content = urlParams.get("utm_content");
    const utm_term = urlParams.get("utm_term");

    let props = {
      page_name: page_name,
      platform: isApp() ? "App" : isMobile ? "Mobile" : "Desktop",
      sub_channel_id: window.sub_channel_id || "",
      channel_id: window.channel_id || "",
      date_time: dt,
      campaign_name: spl,
      referrer: document.referrer,
      utm_campaign,
      utm_medium,
      utm_source,
      utm_content,
      utm_term,
    };
    if (window._ctProps) {
      window._ctProps.push(eveName, props);
    } else {
      !window._clevertapEventStack && (window._clevertapEventStack = []);
      window._clevertapEventStack.push({ evntName: eveName, eventObj: props });
    }
  },
  profilePush: function (trackedProp) {
    trackedProp["profile_last_updated"] = new Date();
    if (window?.clevertap?.profile) {
      window.clevertap.profile.push({ Site: trackedProp });
    }
  },
  registerProfilePush: function (trackedProp) {
    let dt = new Date();
    let spl = this.getQueryString()["spl"];
    if (!spl) spl = "";
    trackedProp["platform"] = isApp() ? "App" : isMobile ? "Mobile" : "Desktop";
    trackedProp["acquisition_campaign"] = spl;
    trackedProp["login_date"] = dt;
    trackedProp["reg_date"] = dt;
    trackedProp["profile_last_updated"] = dt;
    trackedProp["resume_image"] = "No";
    trackedProp["mobile_verification"] = "No";
    trackedProp["email_verification"] = "No";
    if (window?.clevertap?.onUserLogin) {
      window.clevertap.onUserLogin.push({ Site: trackedProp });
    }
  },
  onuserLoginPush: function (trackedProp) {
    if (window?.clevertap?.onUserLogin) {
      window.clevertap.onUserLogin.push({ Site: trackedProp });
    }
  },
  onuserLoginPushEmail: function (email) {
    let trackedProp = {
      Email: email,
    };
    window.clevertap.onUserLogin.push({ Site: trackedProp });
  },
  onuserLoginPushNumber: function (mobileNo) {
    let trackedProp = {
      Phone: mobileNo,
    };
    window.clevertap.onUserLogin.push({ Site: trackedProp });
  },
  getQueryString() {
    let lets = {};
    let parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        lets[key] = value;
      },
    );
    return lets;
  },
  getPlatform() {
    let ua = navigator.userAgent;
    if (
      /(iPad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i.test(
        ua,
      )
    )
      return "Tablet";
    else if (
      /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/i.test(
        ua,
      )
    )
      return "Mobile";
    else return "Desktop";
  },
  splTrackEvent: function (action, splAction, payload) {
    let date_time = new Date();
    // Get spl from current URL
    const urlParams = new URLSearchParams(window.location.search);
    let splParam = urlParams.get("spl") ?? "";
    // Check if return_url contains spl parameter
    const returnUrl = urlParams.get("return_url");
    if (returnUrl && !splParam) {
      try {
        // First, decode the return_url value
        const decodedReturnUrl = decodeURIComponent(returnUrl);

        // Find the query string part (after the ? or encoded %3F)
        let queryString = "";
        if (decodedReturnUrl.includes("?")) {
          queryString = decodedReturnUrl.split("?")[1];
          // In case encoded doesn't work
        } else if (decodedReturnUrl.includes("%3F")) {
          queryString = decodedReturnUrl.split("%3F")[1];
        }

        if (queryString) {
          // Use URLSearchParams to parse the query string
          const returnUrlParams = new URLSearchParams(queryString);
          const returnSplParam = returnUrlParams.get("spl");
          if (returnSplParam) {
            splParam = returnSplParam;
          }
        }
      } catch (error) {
        console.error("Error parsing return_url:", error);
      }
    }

    payload["splSource"] = splParam;
    payload["dateTime"] = date_time;
    payload["marketingChannel"] = getMarketingChannel(splParam);
    payload["OS"] = getOS();
    payload["platform"] = this.getPlatform();
    payload["displayDateTime"] = this.getDateFormatted();
    payload["screen"] = screen.width + "*" + screen.height;
    const siteProps = getSiteProps(window.location.hostname);
    const siteContext = siteProps?.site_map || "";
    const countryCode = siteProps?.country_code || "";

    let properties = {
      events: [
        {
          action: action,
          splAction: splAction,
          payload: payload,
          apiHeaders: {
            "X-Language-Code": "EN",
            "X-Source-Country": countryCode,
            "X-Source-Site-Context": siteContext,
          },
        },
      ],
    };
    if (typeof document === "object")
      getCookie("MSSOCLIENT") && publishEvent(properties);
  },
  getDateFormatted() {
    let date_time = new Date();
    const dd = date_time.getDate();
    const mm = date_time.getMonth() + 1;
    const yy = date_time.getFullYear();
    const hh = date_time.getHours();
    const mins = date_time.getMinutes();

    date_time = mm + "/" + dd + "/" + yy + " " + hh + ":" + mins;
    return date_time;
  },
  removeTrailingSlash(url) {
    return url.endsWith("/") ? url.slice(0, -1) : url;
  },
};
